import "./footer.scss";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { PATH_URL } from "src/interfaces";
import { isMobile, isMobileOnly, isTablet } from "react-device-detect";
import { InfoIcon, LockIcon } from "src/assets/icons";
import { NafutelMarketLogo, NafutelReserveLogo } from "../logo";
import { useTranslation } from "react-i18next";
interface IProps {
  isResale?: boolean;
}

const renderLogo = () => {
  return (
    <div style={{ display: "flex" }}>
      <NafutelReserveLogo />
      <NafutelMarketLogo
        styles={{ marginLeft: `${isMobileOnly ? "30px" : "50px"}` }}
      />
    </div>
  );
};

function FooterComponent({ isResale = false }: IProps) {
  const { t } = useTranslation();
  return (
    <div
      className={
        isMobileOnly
          ? "FooterStyleMobile"
          : isTablet
          ? "FooterStyleTablet"
          : "FooterStyle"
      }
    >
      {isMobile ? (
        <div>
          <div className="wrap-1">
            <div className={"logo"}>{renderLogo()}</div>
            <div style={{ fontSize: "13px" }}>
              ©NaFuTeL　All rights reserved.
            </div>
            <div
              className="flex d-flex"
              style={{ gap: 45, marginTop: 40, fontWeight: 500 }}
            >
              <div>
                <Link
                  className="nav-link text-menu"
                  to={`${
                    isResale
                      ? PATH_URL.RESALE_MY_PAGE
                      : PATH_URL.RESERVATION_MY_PAGE
                  }`}
                >
                  My page
                </Link>
              </div>
              <div>
                <Link className="nav-link text-menu" to="/">
                  FAQ
                </Link>
              </div>
              <div>
                <Link className="nav-link text-menu" to="/">
                  Contact
                </Link>
              </div>
            </div>
          </div>
          <div className="wrap-2">
            <div className="wrap-info-text">
              <div className="text-top">ADDRESS</div>
              <div className="dash"></div>
            </div>
            <div
              style={{
                marginTop: 15,
                display: "flex",
                textDecoration: "underline",
                gap: 8,
                color: "#9c8b58",
              }}
            >
              <InfoIcon />
              <div>info@nafutel.com</div>
            </div>
            <div
              style={{
                marginTop: 15,
                display: "flex",
                textDecoration: "underline",
                gap: 8,
                color: "#9c8b58",
              }}
            >
              <LockIcon />
              <div>{t("footer.policy")}</div>
            </div>
          </div>
        </div>
      ) : (
        <Row style={{ height: "100%", marginLeft: 0, marginRight: 0 }}>
          <Col xs={6}>
            <div
              className="wrap-1"
              style={{ paddingLeft: window.screen.width / 6 - 10 }}
            >
              {renderLogo()}
              <div className="wrap-text-center">
                <div className="brand-text">©NaFuTeL　All rights reserved.</div>
                {/* <div className="wrap-social">
                  <svg
                    width="24"
                    height="20"
                    viewBox="0 0 24 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.53902 19.515C16.5954 19.515 21.551 12.0048 21.551 5.503C21.551 5.29172 21.551 5.08043 21.5414 4.86915C22.5018 4.17767 23.3373 3.30372 24 2.31453C23.1164 2.70828 22.1657 2.96759 21.1669 3.09244C22.1849 2.48739 22.9628 1.51741 23.3373 0.364946C22.3866 0.931573 21.3301 1.33493 20.2065 1.55582C19.3037 0.595438 18.0264 0 16.6146 0C13.8968 0 11.6879 2.20888 11.6879 4.92677C11.6879 5.31092 11.7359 5.68547 11.8127 6.05042C7.72149 5.84874 4.09124 3.87995 1.66146 0.902761C1.2389 1.63265 0.998799 2.47779 0.998799 3.38055C0.998799 5.09004 1.87275 6.59784 3.18848 7.48139C2.38175 7.45258 1.62305 7.23169 0.960384 6.86675V6.93397C0.960384 9.31573 2.66026 11.3133 4.90756 11.7647C4.4946 11.88 4.06242 11.9376 3.61104 11.9376C3.29412 11.9376 2.98679 11.9088 2.68908 11.8511C3.31333 13.8103 5.13805 15.2317 7.28932 15.2701C5.59904 16.5954 3.47659 17.383 1.17167 17.383C0.777911 17.383 0.384154 17.3637 0 17.3157C2.17047 18.6987 4.76351 19.515 7.53902 19.515Z"
                      fill="white"
                    />
                  </svg>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.9831 24H7.01695C3.14776 24 0 20.8522 0 16.9831V7.01695C0 3.14776 3.14776 0 7.01695 0H16.9831C20.8522 0 24 3.14776 24 7.01695V16.9831C24 20.8522 20.8522 24 16.9831 24ZM7.01695 2.23729C4.38142 2.23729 2.23729 4.38142 2.23729 7.01695V16.9831C2.23729 19.6186 4.38142 21.7627 7.01695 21.7627H16.9831C19.6186 21.7627 21.7627 19.6186 21.7627 16.9831V7.01695C21.7627 4.38142 19.6186 2.23729 16.9831 2.23729H7.01695Z"
                      fill="white"
                    />
                    <circle
                      cx="20.959"
                      cy="5.26216"
                      r="1.43372"
                      transform="rotate(-76.7175 20.959 5.26216)"
                      fill="white"
                    />
                    <path
                      d="M11.9999 18.4432C8.44725 18.4432 5.55688 15.5529 5.55688 12.0002C5.55688 8.44749 8.44725 5.55713 11.9999 5.55713C15.5527 5.55713 18.443 8.44749 18.443 12.0002C18.443 15.5529 15.5527 18.4432 11.9999 18.4432ZM11.9999 7.88083C9.72856 7.88083 7.88058 9.7288 7.88058 12.0002C7.88058 14.2716 9.72856 16.1195 11.9999 16.1195C14.2714 16.1195 16.1193 14.2716 16.1193 12.0002C16.1193 9.7288 14.2714 7.88083 11.9999 7.88083Z"
                      fill="white"
                    />
                  </svg>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 17.9895 4.38823 22.954 10.125 23.8542V15.4688H7.07812V12H10.125V9.35625C10.125 6.34875 11.9165 4.6875 14.6576 4.6875C15.9705 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8306C14.3399 7.875 13.875 8.80001 13.875 9.74899V12H17.2031L16.6711 15.4688H13.875V23.8542C19.6118 22.954 24 17.9895 24 12Z"
                      fill="white"
                    />
                  </svg>
                </div> */}
              </div>
            </div>
          </Col>
          <Col xs={6} style={{ paddingRight: 0 }}>
            <div className="wrap-2">
              <ul
                className="nav nav-pills "
                style={{
                  position: "relative",
                  left: -15,
                  marginBottom: 30,
                  fontFamily: "Outfit",
                }}
              >
                <li className="nav-item">
                  <Link
                    className="nav-link text-menu"
                    to={`${
                      isResale
                        ? PATH_URL.RESALE_MY_PAGE
                        : PATH_URL.RESERVATION_MY_PAGE
                    }`}
                  >
                    My page
                  </Link>
                </li>
                {/* <li className="nav-item">
                  <Link className="nav-link text-menu" to="/">
                    About
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link text-menu" to="/">
                    Service
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link text-menu" to="/">
                    Sitemap
                  </Link>
                </li> */}
                <li className="nav-item">
                  <Link className="nav-link text-menu" to="/">
                    FAQ
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link text-menu" to="/">
                    Contact
                  </Link>
                </li>
              </ul>
              <div className="wrap-info-text">
                <div className="text-top">ADDRESS</div>
                <div className="dash"></div>
              </div>
              <div
                style={{
                  marginTop: 25,
                  display: "flex",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    gap: 8,
                  }}
                >
                  <InfoIcon />
                  <div
                    style={{ textDecoration: "underline", color: "#9c8b58" }}
                  >
                    info@nafutel.com
                  </div>
                </div>
                <div
                  style={{
                    marginLeft: "50px",
                    display: "flex",
                    alignItems: "center",
                    color: "#9c8b58",
                    gap: 8,
                  }}
                >
                  <LockIcon />
                  <span style={{ marginBottom: "-5px" }}>
                    {t("footer.policy")}
                  </span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
}

export default FooterComponent;
